(function (w, e, b, g, a, i, n, s) {
    w['ITCLKOBJ'] = a;
    w[a] = w[a] || function () {
        (w[a].q = w[a].q || []).push(arguments)
    }, w[a].l = 1 * new Date();
    i = e.createElement(b), n = e.getElementsByTagName(b)[0];
    i.async = 1;
    i.src = g;
    n.parentNode.insertBefore(i, n)
})(window, document, 'script', 'https://analytics.webgains.io/clk.min.js', 'ITCLKQ');
ITCLKQ('set', 'internal.cookie', true);
ITCLKQ('set', 'internal.api', true);
ITCLKQ('click');

(function (w, e, b, g, a, i, n, s) {
    w['ITCVROBJ'] = a;
    w[a] = w[a] || function () {
        (w[a].q = w[a].q || []).push(arguments)
    }, w[a].l = 1 * new Date();
    i = e.createElement(b),
        n = e.getElementsByTagName(b)[0];
    i.async = 1;
    i.src = g;
    n.parentNode.insertBefore(i, n)
})(window, document, 'script', 'https://analytics.webgains.io/cvr.min.js', 'ITCVRQ');


document.addEventListener("DOMContentLoaded", () => {

    if (typeof wgdata !== 'undefined') {

        ITCVRQ('set', 'trk.programId', wgdata.wgprogramid);
        ITCVRQ('set', 'cvr', {
            value: wgdata.amount,
            currency: wgdata.currency,
            language: wgdata.wglanguage,
            eventId: wgdata.wgeventid,
            orderReference: wgdata.reference,
            comment: 'Subscription plan payment',
            multiple: '',
            checksum: '',
            items: '',
            customerId: wgdata.customer_id,
            voucherId: '',
            location: document.referrer || document.location.href || 'https://www.secretflightclub.com/'
        });

        ITCVRQ('conversion');

        const label = 'CustomerID - ' + wgdata.customer_id + ', Currency - ' + wgdata.currency + ', Reference - ' + wgdata.reference + ', Amount - ' + wgdata.amount;
        // Google Analytics
        gtag('event', 'customer', {
            event_category: 'customer',
            event_action: 'submit',
            event_label: label // Name of your form.
        });

        //Send the conversion tracking to Google
        gtag('event', 'conversion', { 'send_to': 'AW-396595741/KclTCMis8s0DEJ2kjr0B', 'transaction_id': wgdata.reference });
    }

});

